export const WALLPAPER_LANG_KEY = "wallpaper-lang";
export const WALLPAPER_COUNTRY_KEY = "wallpaper-country";
/**
 * 流量來源，同時也是「LIFF 版 / 國際 web 版」的分流依據：
 * LIFF 入口（WallpaperLiffPage）寫入 "liff"，國際 web 版由登入 Guard 寫入國家代碼 / 預設 hk。
 */
export const WALLPAPER_FROM_KEY = "wallpaper-from";
const LIFF_FROM = "liff";

/**
 * sessionStorage 不可用時的備援（無痕 / 使用者封鎖網站資料）。
 * 撐不過整頁 reload，但同一次瀏覽過程中足以維持來源判斷正確。
 */
const memoryStore: Record<string, string> = {};

/** 讀取已存的參數（sessionStorage 讀不到就退回記憶體備援）。 */
export function readStoredParam(key: string): string | null {
	try {
		return sessionStorage.getItem(key) ?? memoryStore[key] ?? null;
	} catch {
		return memoryStore[key] ?? null;
	}
}

/** 有值才寫入（空值不覆蓋既有）；記憶體與 sessionStorage 各寫一份。 */
export function persistParam(
	key: string,
	value: string | null | undefined,
): void {
	if (!value) return;
	memoryStore[key] = value;
	try {
		sessionStorage.setItem(key, value);
	} catch {
		// 寫不進去也沒關係，記憶體備援還在
	}
}

/** 取得有效參數：URL 優先，否則沿用 sessionStorage。 */
export function resolveParam(
	urlValue: string | null | undefined,
	key: string,
): string | null {
	return urlValue ?? readStoredParam(key);
}

/** 目前 country（其他頁需要時可直接呼叫）。 */
export function getStoredCountry(): string | null {
	return readStoredParam(WALLPAPER_COUNTRY_KEY);
}

/** 目前 lang（其他頁需要時可直接呼叫）。 */
export function getStoredLang(): string | null {
	return readStoredParam(WALLPAPER_LANG_KEY);
}

/**
 * 目前流量來源 from：
 * 優先讀登入時寫入的值；若沒有（例外情況）則用 country，再沒有預設香港 "hk"。
 */
export function getStoredFrom(): string {
	return readStoredParam(WALLPAPER_FROM_KEY) ?? getStoredCountry() ?? "hk";
}

/** 標記為 LIFF 流程：只有走 LIFF 入口（WallpaperLiffPage）時才呼叫。 */
export function markLiffFlow(): void {
	persistParam(WALLPAPER_FROM_KEY, LIFF_FROM);
}

/**
 * 是否為台灣 LIFF 流程。
 */
export function isLiffFlow(): boolean {
	return readStoredParam(WALLPAPER_FROM_KEY) === LIFF_FROM;
}
